module.exports = __webpack_public_path__ + "media/images/dashboards/insulins-776ddb07b282809b7ebcaf387fabd032.png";